/* eslint-disable vue/no-unused-vars */
<template>
  <div class="transactions">
    <a-card
      :headStyle="{ marginBottom: '0', paddingBottom: '0', minHeight: '40px' }"
      :bodyStyle="{ paddingTop: '3px' }"
      class="card"
    >
      <div v-if="showHeader" slot="title" class="transaction-list-head-title">
        <div class="search-wrapper">
          <a-input-search
            placeholder="Buscar..."
            enterButton
            @change="handleSearch"
          />
        </div>
      </div>
      <div v-if="showHeader" slot="extra" class="extraStyle">
        <a-dropdown
          placement="bottomCenter"
          style="margin-right:1rem"
          v-if="!dateFilter.key"
        >
          <a class="ant-dropdown-link">
            <span class="status-label">Período: Completo </span>
            <a-icon type="down"
          /></a>
          <a-menu slot="overlay" @click="handleDateFilterClick">
            <a-menu-item
              v-for="option in dateFilterOptions"
              :key="option.key"
              >{{ option.value }}</a-menu-item
            >
            <a-sub-menu key="months" title="Mes">
              <a-menu-item v-for="option in dateFilterMonths" :key="option.key">
                {{ option.value }}</a-menu-item
              >
            </a-sub-menu>
          </a-menu>
        </a-dropdown>
        <span v-else class="order-by-label">
          Período:
          <a-tag
            closable
            @click="handleDateFilterClose"
            :color="dateFilter.color"
            >{{ dateFilter.value }}
          </a-tag>
        </span>
        <a-dropdown
          placement="bottomCenter"
          style="margin-right:1rem"
          v-if="!orderBySelection.key"
        >
          <a class="ant-dropdown-link">
            <span class="order-by-label">Orden: Fecha </span>
            <a-icon type="down"
          /></a>
          <a-menu slot="overlay" @click="handleOrderByClick">
            <a-menu-item v-for="option in orderByOptions" :key="option.key">{{
              option.value
            }}</a-menu-item>
          </a-menu>
        </a-dropdown>
        <span
          v-else-if="orderBySelection.direction == 'asc'"
          class="order-by-label"
        >
          Orden:
          <a-tag @click="handleOrderAscClick" color="green"
            >{{ orderBySelection.value }} <a-icon type="sort-ascending" />
          </a-tag>
        </span>
        <span v-else class="order-by-label">
          Orden:
          <a-tag closable @click="handleOrderByClose" color="orange"
            >{{ orderBySelection.value }} <a-icon type="sort-descending" />
          </a-tag>
        </span>

        <a-dropdown placement="bottomCenter" v-if="!statusFilter.key">
          <a class="ant-dropdown-link">
            <span class="status-label">Estado: Todos </span>
            <a-icon type="down"
          /></a>
          <a-menu slot="overlay" @click="handleStatusFilterClick">
            <a-menu-item
              v-for="option in statusFilterOptions"
              :key="option.key"
              >{{ option.value }}</a-menu-item
            >
          </a-menu>
        </a-dropdown>
        <span v-else class="order-by-label">
          Estado:
          <a-tag
            closable
            @click="handleStatusFilterClose"
            :color="statusFilter.color"
            >{{ statusFilter.value }}
          </a-tag>
        </span>

        <export-excel
          ref="exporter"
          :data="exportData"
          :columns="exportColumns"
          :filename="'transacciones-export'"
          :sheetname="'Transacciones'"
          @exportRequested="loadExportData"
          style="margin-left:10px"
        />
      </div>
      <div v-if="displayEmptyMessage" style="margin-top:2rem">
        <h5 style="color:#555;">No se registran transacciones.</h5>
      </div>
      <div
        class="demo-infinite-container"
        v-infinite-scroll="loadMoreTransactions"
        :infinite-scroll-disabled="scrollDisabled"
        :infinite-scroll-distance="15"
        infinite-scroll-event-target="window"
      >
        <a-list :dataSource="listData" size="small">
          <a-list-item slot="renderItem" slot-scope="item" key="item.id">
            <a-list-item-meta>
              <span slot="avatar">
                <div class="xsStatus" style="padding-bottom: 5px">
                  <a-tooltip placement="right" style="cursor:default;">
                    <span slot="title">
                      <p
                        style="margin-bottom:1rem"
                        v-if="item.errorDescription"
                      >
                        ERROR: <br />
                        {{ makeErrorReadable(item.errorDescription) }}
                      </p>

                      <div
                        v-if="item.statusId == 10 || item.statusId == 11"
                        style="margin-bottom:0.5rem"
                      >
                        <div
                          v-if="item.statusId == 11"
                          style="margin-bottom:0.5rem"
                        >
                          Tarjeta validada y reintegro de monto mínimo.
                        </div>
                        REINTEGRO <br />
                        Fecha:
                        {{ item.dateRefunded | moment("DD/MM/YYYY HH:mm") }}
                        <br />
                        Saldo Actual:
                        {{
                          new Intl.NumberFormat("es-AR", {
                            style: "currency",
                            currency: "ARS"
                          }).format(item.amount)
                        }}
                        <br />
                        Reintegro:
                        {{
                          new Intl.NumberFormat("es-AR", {
                            style: "currency",
                            currency: "ARS"
                          }).format(item.amountRefunded)
                        }}
                        <br />
                        Cobro Original:
                        {{
                          new Intl.NumberFormat("es-AR", {
                            style: "currency",
                            currency: "ARS"
                          }).format(item.amount + item.amountRefunded)
                        }}
                        <br />
                        <span v-if="item.refunder">
                          Usuario:
                          {{ item.refunder.name }}
                        </span>
                      </div>
                      <p style="margin-bottom:0.5rem">
                        CLIENTE <br />
                        {{ item.customer.firstName }}
                        {{ item.customer.lastName }} <br />
                        <span v-if="item.customer.DNI"
                          >DNI: {{ item.customer.DNI }}<br
                        /></span>
                        Tel: {{ item.customer.phone1 }}<br />
                        Email: {{ item.customer.email }}
                      </p>
                      <p style="margin-bottom:0.5rem">
                        MEDIO DE PAGO<br />
                        {{ item.paymentCard.ownerName }}<br />
                        {{ item.paymentCard.paymentCourier.name }}
                        XXXX XXXX XXXX {{ item.paymentCard.lastFourDigits
                        }}<br />
                        Expira:
                        {{ item.paymentCard.expirationDate | moment("MM/YY") }}
                      </p>
                    </span>

                    <a-tag v-if="item.refunded" color="orange"
                      >Reintegrado <a-icon type="undo" :rotate="130"
                    /></a-tag>
                    <span v-else-if="item.statusId == '2'">
                      <a-tag color="green" style="cursor:default"
                        >Pagado <a-icon type="check-circle" /><br /><span
                          class="transaction-gray-text"
                        >
                          {{ item.dateProcessed | moment("DD/MM HH:mm") }}</span
                        ></a-tag
                      >
                    </span>
                    <span v-else-if="item.statusId == '11'">
                      <a-tag color="green" style="cursor:default"
                        >Tarjeta Validada
                        <a-icon type="check-circle" /><br /><span
                          class="transaction-gray-text"
                        >
                          {{ item.dateProcessed | moment("DD/MM HH:mm") }}</span
                        ></a-tag
                      >
                    </span>
                    <span v-else-if="item.statusId == '5'">
                      <a-tag color="pink"
                        >Rechazado <a-icon type="close-circle"
                      /></a-tag>
                    </span>
                    <span v-else-if="item.statusId == '8'">
                      <a-tag color="pink"
                        >Error <a-icon type="close-circle"
                      /></a-tag>
                    </span>
                    <a-tag v-else-if="item.statusId == '10'" color="orange"
                      >Reintegrado <a-icon type="undo" :rotate="130"
                    /></a-tag>
                    <span v-else-if="item.statusId == '12'">
                      <a-tag color="orange" style="cursor:default"
                        >Pagado con Error
                        <a-icon type="check-circle" /><br /><span
                          class="transaction-gray-text"
                        >
                          {{ item.dateProcessed | moment("DD/MM HH:mm") }}</span
                        ></a-tag
                      >
                    </span>
                    <span v-else-if="item.statusId == '6'">
                      <a-tag color="pink"
                        >Cancelado <a-icon type="close-circle"
                      /></a-tag>
                    </span>
                    <span v-else-if="item.statusId == '1'"
                      ><a-tag color="orange"
                        >Pendiente <a-icon type="minus-circle"
                      /></a-tag>
                    </span>
                    <span v-else-if="item.statusId == '9'">
                      <a-tag color="green" style="cursor:default"
                        >Pre-Aprobado <a-icon type="check-circle"
                      /></a-tag>
                    </span>
                    <span v-if="item.statusId == '3'">
                      <a-tag color="orange"
                        >Revisión <a-icon type="minus-circle"
                      /></a-tag>
                    </span>
                    <span v-else-if="item.statusId == '4'">
                      <a-tag color="organge"
                        >En Disputa <a-icon type="minus-circle"
                      /></a-tag>
                    </span>
                    <span v-else-if="item.statusId == '7'">
                      <a-tag color="orange"
                        >En Proceso <a-icon type="minus-circle"
                      /></a-tag>
                    </span>
                  </a-tooltip>
                </div>
                <span
                  class="xlStatus transaction-gray-text"
                  :class="[
                    $style.idBox,
                    item.refunded
                      ? $style.orange
                      : item.statusId == '2' ||
                        item.statusId == '9' ||
                        item.statusId == '11'
                      ? $style.green
                      : item.statusId == '1' ||
                        item.statusId == '3' ||
                        item.statusId == '4' ||
                        item.statusId == '7' ||
                        item.statusId == '10' ||
                        item.statusId == '12'
                      ? $style.orange
                      : item.statusId == '5' ||
                        item.statusId == '6' ||
                        item.statusId == '8'
                      ? $style.pink
                      : item.statusId == '11'
                      ? $style.blue
                      : $style.blue
                  ]"
                >
                  {{ item.dateProcessed | moment("DD/MM HH:mm") }}
                </span>
              </span>
              <h4 class="transaction" slot="title">
                <router-link :key="'view'" :to="`/transactions/${item.id}`">
                  <strong
                    v-if="orderBySelection.key == 'description'"
                    style="color:#000"
                  >
                    {{ item.description }}
                  </strong>
                  <span v-else style="font-weight:normal">
                    {{ item.description }}
                  </span>
                  <br class="br-sm" />
                  <span class="transaction-gray-text">
                    #{{ item.id }}</span
                  > </router-link
                >&nbsp;

                <span>
                  <strong
                    v-if="orderBySelection.key == 'firstName'"
                    style="color:#000"
                    class="transaction-gray-text"
                  >
                    {{ item.customer.firstName }} {{ item.customer.lastName }}
                  </strong>
                  <strong
                    v-else-if="orderBySelection.key == 'lastName'"
                    style="color:#000"
                    class="transaction-gray-text"
                  >
                    {{ item.customer.lastName }}, {{ item.customer.firstName }}
                  </strong>
                  <span v-else class="transaction-gray-text">
                    {{ item.customer.firstName }} {{ item.customer.lastName }}
                  </span>
                </span>
                <!--</a-tooltip>-->
                &nbsp;

                <span class="xlStatus">
                  <a-tooltip placement="right" style="cursor:default;">
                    <span slot="title">
                      <p
                        style="margin-bottom:1rem"
                        v-if="item.errorDescription"
                      >
                        {{ makeErrorReadable(item.errorDescription) }}
                      </p>

                      <p style="margin-bottom:0.5rem">
                        CLIENTE <br />
                        {{ item.customer.firstName }}
                        {{ item.customer.lastName }} <br />
                        <span v-if="item.customer.DNI"
                          >DNI: {{ item.customer.DNI }}<br
                        /></span>
                        Tel: {{ item.customer.phone1 }}<br />
                        Email: {{ item.customer.email }}
                      </p>
                      <p style="margin-bottom:0.5rem">
                        MEDIO DE PAGO<br />
                        {{ item.paymentCard.ownerName }}<br />
                        {{ item.paymentCard.paymentCourier.name }}
                        XXXX XXXX XXXX {{ item.paymentCard.lastFourDigits
                        }}<br />
                        Expira:
                        {{ item.paymentCard.expirationDate | moment("MM/YY") }}
                      </p>
                      <!--
                    <p style="margin-bottom:0.5rem">
                      DATOS CONTABLES<br />
                      Producto:
                      <span v-if="item.product">{{ item.product.name }}</span
                      ><br />
                      Centro de Costo: {{ item.costCenter.name }}<br />
                      Unidad de Negocios: {{ item.businessUnit.name }}<br />
                    </p>
                    -->
                    </span>

                    <a-tag v-if="item.refunded" color="orange"
                      >Reintegrado <a-icon type="undo" :rotate="130"
                    /></a-tag>
                    <span v-else-if="item.statusId == '2'">
                      <!--<a-tooltip :title="item.description" placement="right"
                    >--><a-tag color="green" style="cursor:default"
                        >Pagado <a-icon type="check-circle"
                      /></a-tag>
                      <!--</a-tooltip>-->
                    </span>
                    <span v-else-if="item.statusId == '5'">
                      <a-tag color="pink"
                        >Rechazado <a-icon type="close-circle"
                      /></a-tag>
                    </span>
                    <span v-else-if="item.statusId == '8'">
                      <a-tag color="pink"
                        >Error <a-icon type="close-circle"
                      /></a-tag>
                    </span>
                    <a-tag v-else-if="item.statusId == '10'" color="orange"
                      >Reintegrado <a-icon type="undo" :rotate="130"
                    /></a-tag>
                    <span v-else-if="item.statusId == '11'">
                      <a-tag color="green" style="cursor:default"
                        >Tarjeta Validada <a-icon type="check-circle"
                      /></a-tag>
                    </span>
                    <span v-else-if="item.statusId == '12'">
                      <a-tag color="orange" style="cursor:default"
                        >Pagado con Error <a-icon type="check-circle"
                      /></a-tag>
                    </span>
                    <span v-else-if="item.statusId == '1'">
                      <!--<a-tooltip
                    :title="'La transacción está pendiente de cobro.'"
                    placement="right"
                    >--><a-tag color="orange"
                        >Pendiente <a-icon type="minus-circle"/></a-tag
                      ><!--
                  </a-tooltip>-->
                    </span>
                    <span v-else-if="item.statusId == '9'">
                      <!--<a-tooltip :title="item.description" placement="right"
                    >--><a-tag color="green" style="cursor:default"
                        >Pre-Aprobado <a-icon type="check-circle"
                      /></a-tag>
                      <!--</a-tooltip>-->
                    </span>
                    <!--<a-tooltip v-else placement="right" style="cursor:default">
                  <span slot="title">
                    <p style="margin-bottom:0.5rem">
                      <span
                        v-if="item.statusId != '8' && item.errorDescription"
                      >
                        {{ makeErrorReadable(item.errorDescription) }}
                      </span>
                      <span v-else-if="item.errorDescription">
                        {{ makeErrorReadable(item.errorDescription) }}
                      </span>
                    </p>
                  </span>
                  -->
                    <span v-if="item.statusId == '3'">
                      <a-tag color="orange"
                        >Revisión <a-icon type="minus-circle"
                      /></a-tag>
                    </span>
                    <span v-else-if="item.statusId == '4'">
                      <a-tag color="organge"
                        >En Disputa <a-icon type="minus-circle"
                      /></a-tag>
                    </span>
                    <span v-else-if="item.statusId == '6'">
                      <a-tag color="pink"
                        >Cancelado <a-icon type="close-circle"
                      /></a-tag>
                    </span>
                    <span v-else-if="item.statusId == '7'">
                      <a-tag color="orange"
                        >En Proceso <a-icon type="minus-circle"
                      /></a-tag>
                    </span>
                  </a-tooltip>
                </span>
              </h4>

              <div slot="description">
                <strong v-if="orderBySelection.key == 'DNI'" style="color:#000">
                  {{ item.customer.DNI }}
                </strong>
                <strong
                  v-else-if="orderBySelection.key == 'email'"
                  style="color:#000"
                >
                  {{ item.customer.email }}
                </strong>
                <strong
                  v-else-if="orderBySelection.key == 'product'"
                  style="color:#000"
                >
                  Producto:
                  <span v-if="item.product">{{ item.product.name }}</span>
                  <span class="transaction-gray-text">
                    | CC: {{ item.costCenter.name }} | UN:
                    {{ item.businessUnit.name }}</span
                  >
                </strong>
                <strong
                  v-else-if="orderBySelection.key == 'costCenter'"
                  style="color:#000"
                >
                  <span class="transaction-gray-text"
                    >Producto:
                    <span v-if="item.product">{{ item.product.name }}</span>
                    |</span
                  >
                  CC: {{ item.costCenter.name }}
                  <span class="transaction-gray-text"
                    >| UN: {{ item.businessUnit.name }}</span
                  >
                </strong>
                <strong
                  v-else-if="orderBySelection.key == 'businessUnit'"
                  style="color:#000"
                >
                  <span class="transaction-gray-text"
                    >Producto:
                    <span v-if="item.product">{{ item.product.name }}</span> |
                    CC: {{ item.costCenter.name }} |</span
                  >
                  UN: {{ item.businessUnit.name }}
                </strong>
              </div>
            </a-list-item-meta>

            <template slot="actions">
              <a-tooltip placement="left" style="cursor:default">
                <span slot="title">
                  <div
                    v-if="item.statusId == 10 || item.statusId == 11"
                    style="margin-bottom:0.5rem"
                  >
                    <div
                      v-if="item.statusId == 11"
                      style="margin-bottom:0.5rem"
                    >
                      Tarjeta validada y reintegro de monto mínimo.
                    </div>
                    REINTEGRO <br />
                    Monto Reintegro:
                    {{
                      new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS"
                      }).format(item.amountRefunded)
                    }}
                    <br />
                    Fecha:
                    {{ item.dateRefunded | moment("DD/MM/YYYY HH:mm") }}
                    <br />
                    Cobro Original:
                    {{
                      new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS"
                      }).format(item.amount + item.amountRefunded)
                    }}
                    <br />
                    Saldo Actual:
                    {{
                      new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS"
                      }).format(item.amount)
                    }}
                    <br />
                    <span v-if="item.refunder">
                      Reintegrado por:
                      {{ item.refunder.name }}
                    </span>
                  </div>
                  <p style="margin-bottom:0.5rem">
                    DETALLE DE PAGO<br />
                    Monto Ticket: {{ formatPrice(item.finalPrice) }}
                    <br />
                    <span v-if="item.plan == 'AHORA'">
                      <!-- En los planes ahora, todas las tarjetas se transaccionan en prisma con el numero de cuotas modificado (13,16,7 y 8) excepto por american express que se debe transaccionar con el numero de cuotas comunes -->
                      <span v-if="item.paymentCard.paymentCourier.id == 3">
                        Cuotas: {{ item.installments }} [AHORA]
                      </span>
                      <span v-else>
                        <span v-if="item.installments == 13">
                          Cuotas: 3 [AHORA]
                        </span>
                        <span v-else-if="item.installments == 16">
                          Cuotas: 6 [AHORA]
                        </span>
                        <span v-else-if="item.installments == 7">
                          Cuotas: 12 [AHORA]
                        </span>
                        <span v-else-if="item.installments == 8">
                          Cuotas: 18 [AHORA]
                        </span>
                        <span v-else>
                          Cuotas: {{ item.installments }} [AHORA]
                        </span>
                      </span>
                    </span>
                    <span v-else> Cuotas: {{ item.installments || 0 }} </span>
                    <br />
                    Costo Financiero:
                    {{ formatPrice(item.calculatedFinancialCost) }}
                    <br />
                    Monto a Cobrar: {{ formatPrice(item.amount) }}
                  </p>
                  <p style="margin-bottom:0.5rem">
                    DATOS CONTABLES<br />
                    Producto:
                    <span v-if="item.product">{{ item.product.name }}</span
                    ><span
                      v-if="item.product"
                      style="font-size:smaller; color:#aaa"
                      ><br />[Cód.: {{ item.product.ERPCode }}]</span
                    ><br />
                    Centro de Costo: {{ item.costCenter.name
                    }}<span
                      v-if="item.costCenter"
                      style="font-size:smaller; color:#aaa"
                      ><br />[Cód.: {{ item.costCenter.ERPCode }}]</span
                    ><br />
                    Unidad de Negocios: {{ item.businessUnit.name
                    }}<span
                      v-if="item.businessUnit"
                      style="font-size:smaller; color:#aaa"
                      ><br />[Cód.: {{ item.businessUnit.ERPCode }}]</span
                    ><br />
                  </p>
                </span>

                <h4
                  v-if="
                    item.statusId == '10' ||
                      item.statusId == '11' ||
                      item.refunded
                  "
                  class="transaction"
                  style="text-align:right; text-decoration: line-through;"
                >
                  {{
                    new Intl.NumberFormat("es-AR", {
                      style: "currency",
                      currency: "ARS"
                    }).format(item.amount + item.amountRefunded)
                  }}
                </h4>
                <h4 v-else class="transaction" style="text-align:right">
                  {{
                    new Intl.NumberFormat("es-AR", {
                      style: "currency",
                      currency: "ARS"
                    }).format(item.amount)
                  }}
                </h4>
              </a-tooltip>
              <span
                v-if="
                  (item.statusId == '2' || item.statusId == '12') &&
                    !item.refunded &&
                    $store.state.users.userRoleName == 'Administrador'
                "
              >
                <!-- <a-popconfirm
                  title="Iniciar Reintegro"
                  okText="Reintegrar"
                  cancelText="Cancelar"
                  placement="left"
                  @confirm="() => handleRefund(item.id)"
                > -->
                <a-popconfirm
                  okText="Reintegrar"
                  cancelText="Cancelar"
                  placement="left"
                  @confirm="() => handleRefund(item.id, item.finalPrice)"
                >
                  <a-icon
                    v-if="refundLoading != item.id"
                    type="undo"
                    :rotate="130"
                    :style="{
                      fontSize: '12px',
                      color: '#74708d',
                      cursor: 'pointer'
                    }"
                    class="refundIcon"
                  />
                  <div slot="title">
                    Monto a Reintegrar
                    <div>
                      <a-input
                        :ref="'refundAmount' + item.id"
                        prefix="$"
                        style="70px"
                        :defaultValue="item.finalPrice"
                      />
                    </div>
                  </div>
                </a-popconfirm>
                <a-icon
                  v-if="refundLoading == item.id"
                  type="sync"
                  spin
                  @click="refundLoading = false"
                />
              </span>
              <span v-else-if="item.statusId == '10' || item.statusId == '11'">
                <a-icon
                  type="undo"
                  :rotate="130"
                  :style="{
                    fontSize: '12px',
                    color: '#ddd',
                    cursor: 'default',
                    fontWeight: 'bold'
                  }"
                />
              </span>
              <span v-else>
                <a-icon
                  type="undo"
                  :rotate="130"
                  :style="{
                    fontSize: '12px',
                    color: '#ddd',
                    cursor: 'default'
                  }"
                />
              </span>
            </template>
          </a-list-item>

          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
            style="margin-top:2rem"
          />
          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
          />
          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
          />
        </a-list>
      </div>
    </a-card>
  </div>
</template>
<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
import infiniteScroll from "@/services/vue-infinite-scroll";
import gateway from "@/services/gateway";
import utils from "@/services/utils";
import ExportExcel from "@/components/ExportExcel";

/*
const install = function(Vue) {
  Vue.directive("infiniteScroll", infiniteScroll);
};
if (window.Vue) {
  window.infiniteScroll = infiniteScroll;
  Vue.use(install); // eslint-disable-line
}
infiniteScroll.install = install;
*/
//import { RecycleScroller } from "vue-virtual-scroller";

export default {
  name: "transactionsList",
  directives: { infiniteScroll },
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    subscriptionId: {
      default: null
    },
    customerId: {
      default: null
    },
    paymentLinkId: {
      default: null
    }
  },
  components: {
    //"virtual-scroller": RecycleScroller
    ExportExcel
  },
  data() {
    return {
      pagination: {
        position: "bottom"
      },
      loadingData: false,
      scrollDisabled: false,
      displayEmptyMessage: false,
      listData: [],
      statusFilterSelection: "Activo",
      orderBySelection: { key: null, value: null },
      orderByOptions: [
        { key: "dateProcessed", value: "Fecha" },
        { key: "description", value: "Descripción" },
        { key: "amount", value: "Monto" },
        { key: "statusId", value: "Estado" },
        { key: "firstName", value: "Nombre" },
        { key: "lastName", value: "Apellido" },
        { key: "DNI", value: "DNI" },
        { key: "email", value: "Email" },
        { key: "product", value: "Producto" },
        { key: "costCenter", value: "Centro de Costo" },
        { key: "businessUnit", value: "Unidad de Negocios" }
      ],
      statusFilter: { key: null, value: null },
      statusFilterOptions: [
        { key: "", value: "Todos", color: "" },
        { key: "2", value: "Pagado", color: "green" },
        { key: "1", value: "Pendiente", color: "orange" },
        { key: "3", value: "En Revisión", color: "orange" },
        { key: "4", value: "En Disputa", color: "orange" },
        { key: "5", value: "Rechazado", color: "pink" },
        { key: "6", value: "Cancelado", color: "pink" },
        { key: "7", value: "En Proceso", color: "orange" },
        { key: "8", value: "Error", color: "pink" },
        { key: "10", value: "Reintegrado", color: "orange" },
        { key: "11", value: "Tarjeta Validada", color: "green" },
        { key: "12", value: "Pagado con Error", color: "orange" }
      ],
      dateFilter: { key: null, value: null },
      dateFilterOptions: [
        { key: 0, value: "Completo", color: "" },
        { key: 1, value: "Mes Actual", color: "green" },
        { key: 2, value: "Mes Pasado", color: "orange" },
        { key: 3, value: "Últimos 30 días", color: "green" },
        { key: 4, value: "Últimos 60 días", color: "green" },
        { key: 5, value: "Año Actual", color: "green" },
        { key: 6, value: "Año Pasado", color: "orange" }
        //{ key: 7, value: "Fechas Específicas", color: "pink" }
      ],
      dateFilterMonths: [
        { key: 8, value: "Enero", color: "green" },
        { key: 9, value: "Febrero", color: "green" },
        { key: 10, value: "Marzo", color: "green" },
        { key: 11, value: "Abril", color: "green" },
        { key: 12, value: "Mayo", color: "green" },
        { key: 13, value: "Junio", color: "green" },
        { key: 14, value: "Julio", color: "green" },
        { key: 15, value: "Agosto", color: "green" },
        { key: 16, value: "Septiembre", color: "green" },
        { key: 17, value: "Octubre", color: "green" },
        { key: 18, value: "Noviembre", color: "green" },
        { key: 19, value: "Diciembre", color: "green" }
      ],
      refundLoading: false,
      exportColumns: [
        {
          label: "Id",
          field: "id"
        },
        {
          label: "Fecha",
          field: "dateProcessed"
        },
        {
          label: "Descripción",
          field: "description"
        },
        {
          label: "Nombre",
          field: "customer.firstName"
        },
        {
          label: "Apellido",
          field: "customer.lastName"
        },
        {
          label: "Tel",
          field: "customer.phone1"
        },
        {
          label: "Email",
          field: "customer.email"
        },
        {
          label: "Monto Ticket",
          field: "finalPrice",
          dataFormat: utils.formatExcelPrice
        },
        {
          label: "Cuotas",
          field: "installments"
        },
        {
          label: "Costo Financiero",
          field: "calculatedFinancialCost",
          dataFormat: utils.formatExcelPrice
        },
        {
          label: "Monto a Cobrar",
          field: "amount",
          dataFormat: utils.formatExcelPrice
        },
        {
          label: "Estado",
          field: "statusId"
        },
        {
          label: "CC Nombre",
          field: "paymentCard.ownerName"
        },
        {
          label: "CC Tarjeta",
          field: "paymentCard.paymentCourier.name"
        },
        {
          label: "CC Número",
          field: "paymentCard.lastFourDigits",
          dataFormat: utils.formatExportLastFourDigits
        },
        {
          label: "CC Exp.",
          field: "paymentCard.expirationDate",
          dataFormat: utils.formatExportExpDate
        },
        {
          label: "Producto",
          field: "product.ERPCode"
        },
        {
          label: "Centro de Costos",
          field: "costCenter.ERPCode"
        },
        {
          label: "Unidad de Negocios",
          field: "businessUnit.ERPCode"
        },
        {
          label: "Vendedor",
          field: "seller.name"
        },
        {
          label: "Fecha Reintegro",
          field: "dateRefunded"
        },
        {
          label: "Monto Reintegro",
          field: "amountRefunded",
          dataFormat: utils.formatExcelPrice
        },
        {
          label: "Link de Pagos",
          field: "paymentLink.name"
        },
        {
          label: "Suscripción",
          field: "subscription.name"
        }
      ],
      exportData: null
    };
  },
  methods: {
    ...mapActions({
      loadTransactions: "transactions/load",
      refundTransaction: "transactions/refund",
      loadExportDataFromStore: "transactions/loadExport"
    }),
    async loadExportData() {
      try {
        //console.log("params:", params);
        if (this.loadingData) {
          throw new Error("Data already been loaded.");
        }

        this.loadingData = true;
        const result = await this.loadExportDataFromStore({
          subscriptionId: this.subscriptionId,
          customerId: this.customerId,
          paymentLinkId: this.paymentLinkId
        });
        if (!result || result.length === 0) {
          throw new Error();
        }
        this.exportData = result;
        //this.$refs.exporter.exportExcel();

        this.loadingData = false;
      } catch (err) {
        this.loadingData = false;
        throw err;
      }
    },
    async handleRefund(transactionId, totalAmount) {
      try {
        let refundAmount = parseFloat(
          this.$refs["refundAmount" + transactionId].stateValue
        );

        if (refundAmount > totalAmount) {
          throw new Error(
            "El monto de devolución no puede ser mayor al monto de venta."
          );
        }

        if (refundAmount == totalAmount) {
          refundAmount = null;
        }

        //if (transaction) {
        //this.refundedItemId = transactionId;
        this.refundLoading = transactionId;
        const transaction = await this.refundTransaction({
          transactionId,
          refundAmount
        });
        if (transaction) {
          const listItem = this.listData.filter(
            item => transactionId === item.id
          )[0];
          listItem.refunded = true;
          this.$notification["success"]({
            message: "Proceso de reintegro iniciado con éxito."
          });
        } else {
          this.$notification["warning"]({
            message: "Error en el proceso de reintegro."
          });
        }

        this.refundLoading = false;
      } catch (error) {
        this.refundLoading = false;
        this.$notification["warning"]({
          message: error.message
        });
      }
    },
    // getCardType(paymentCourierCode) {
    //   return gateway.getCardType(paymentCourierCode);
    // },
    async fetchTransactions() {
      try {
        this.displayEmptyMessage = false;
        //console.log("params:", params);
        if (!this.loadingData) {
          this.loadingData = true;
          const result = await this.loadTransactions({
            subscriptionId: this.subscriptionId,
            customerId: this.customerId,
            paymentLinkId: this.paymentLinkId
          });
          if (store.state.transactions.results.length > 0) {
            this.listData = this.listData.concat(
              store.state.transactions.results
            );
          }

          //add results to existing results
          else this.displayEmptyMessage = true;

          this.loadingData = false;
        }
      } catch (error) {
        this.loadingData = false;
        if (error.status == 404) this.displayEmptyMessage = true;
        else {
          this.$notification["warning"]({
            message: error.code,
            description: error.statusCode
          });
        }
      }
    },
    async loadMoreTransactions() {
      try {
        if (
          //todavia hay registros para bajar
          this.$store.state.transactions.totalResults >
          this.$store.state.transactions.page *
            this.$store.state.transactions.pageSize
        ) {
          this.scrollDisabled = true;
          this.$nprogress.start();
          const result = await this.fetchTransactions();
          this.scrollDisabled = false;
          this.$nprogress.done();
        }
        return;
      } catch (error) {
        this.scrollDisabled = false;
        this.$nprogress.done();
        this.$notification["failure"]({
          message: "Error",
          description: `Hubo un error al cargar el listado. Disabled: ${this.scrollDisabled}`
        });
      }
    },
    handleStatusFilterClick(event) {
      this.statusFilter = this.statusFilterOptions.find(opt => {
        return opt.key == event.key;
      });
      this.$store.commit("transactions/SET_STATUS_ID", event.key);
      this.$store.commit("transactions/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchTransactions(true);
    },
    handleStatusFilterClose() {
      this.statusFilter = { key: null, value: null };
      this.$store.commit("transactions/SET_STATUS_ID", null);
      this.$store.commit("transactions/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchTransactions(true);
    },
    handleOrderByClick(event) {
      const orderByOption = this.orderByOptions.find(opt => {
        return opt.key == event.key;
      });
      this.orderBySelection = orderByOption;
      this.orderBySelection.direction = "asc";
      this.$store.commit("transactions/SET_ORDER_BY", {
        orderBy: event.key,
        direction: "asc"
      }); //event.key);
      this.$store.commit("transactions/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchTransactions(true);
    },
    handleOrderAscClick() {
      this.orderBySelection.direction = "desc";
      this.$store.commit("transactions/SET_ORDER_BY", {
        orderBy: this.orderBySelection.key,
        direction: "desc"
      });
      this.$store.commit("transactions/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchTransactions(true);
    },
    handleOrderByClose() {
      this.orderBySelection = { key: null, value: null };
      this.$store.commit("transactions/SET_ORDER_BY", null);
      this.$store.commit("transactions/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchTransactions(true);
    },
    handleSearch(keyword) {
      this.$store.commit("transactions/SET_SEARCH", keyword.target.value);
      this.$store.commit("transactions/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchTransactions(true);
    },
    handleDateFilterClick(event) {
      let dateFrom = null;
      let dateTo = null;
      if (event.key < 8) {
        //período
        this.dateFilter = this.dateFilterOptions.find(opt => {
          return opt.key == event.key;
        });
      } else {
        //mes específico
        this.dateFilter = this.dateFilterMonths.find(opt => {
          return opt.key == event.key;
        });
      }

      if (event.key == 1) {
        dateFrom = this.$moment()
          .startOf("month")
          .toDate();
      } else if (event.key == 2) {
        dateFrom = this.$moment()
          .subtract(1, "months")
          .startOf("month")
          .toDate();
        dateTo = this.$moment()
          .subtract(1, "months")
          .endOf("month")
          .toDate();
      } else if (event.key == 3) {
        dateFrom = this.$moment()
          .subtract(30, "days")
          .toDate();
      } else if (event.key == 4) {
        dateFrom = this.$moment()
          .subtract(60, "days")
          .toDate();
      } else if (event.key == 5) {
        dateFrom = this.$moment()
          .startOf("year")
          .toDate();
      } else if (event.key == 6) {
        dateFrom = this.$moment()
          .subtract(1, "years")
          .startOf("year")
          .toDate();
        dateTo = this.$moment()
          .subtract(1, "years")
          .endOf("year")
          .toDate();
      } else if (event.key >= 8) {
        const month = event.key - 7; //se restan siete solo porque se declaro enero como key=8 y los meses sucesivos.
        const currentMonth = parseInt(this.$moment().format("M"));
        let year;
        if (month > currentMonth) year = parseInt(this.$moment().year()) - 1;
        else year = parseInt(this.$moment().year());

        dateFrom = this.$moment(`${year}-${month}-1`).toDate();
        dateTo = this.$moment(dateFrom)
          .endOf("month")
          .toDate();
      }
      this.$store.commit("transactions/SET_DATE_FROM", dateFrom);
      this.$store.commit("transactions/SET_DATE_TO", dateTo);
      this.$store.commit("transactions/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchTransactions(true);
    },
    handleDateFilterClose() {
      this.dateFilter = { key: null, value: null };
      this.$store.commit("transactions/SET_DATE_FROM", null);
      this.$store.commit("transactions/SET_DATE_TO", null);
      this.$store.commit("transactions/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchTransactions(true);
    },
    makeErrorReadable(err) {
      let message;
      if (err.slice(0, 1) == "{") {
        const jsonErr = JSON.parse(err);
        if (jsonErr.message) message = jsonErr.message;
        else message = gateway.humanizeDecidirError(jsonErr);
      } else message = err;
      return message;
    },
    formatPrice(price) {
      return utils.formatPrice(price);
    }
  },
  created() {
    //window.addEventListener("touchmove", this.loadMoreTransactions);
  },
  mounted() {
    this.$store.commit("transactions/SET_RESET");
    this.fetchTransactions();
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
.editable-row-operations a {
  margin-right: 8px;
}
</style>

<!-- Fue bastante dificil poder poner estilos en los componentes de antd que se apliquen unicamente para este componente, lo que sea que se aplicaba en uno se replicaba en todos los antd usados en otros componentes. Esto es porque a algunos elementos de antd se le aplican los id especiales que deberían llevar por tener el css scoped pero a otros no. A los que si se les aplica le pongo los estilos dentro de la definición scoped, a los que no, les pongo los estilos en la definición sin scoped con el prefijo ".transaction" que es una clase definida en el wrapper div.  -->
<style lang="css" scoped>
.ant-list-sm .ant-list-item {
  padding-top: 10px;
  padding-bottom: 8px;
}
.ant-list-item-meta-avatar {
  margin-top: 3px;
}
.ant-list-item-meta-title {
  margin-bottom: 0;
}
.ant-dropdown-menu-item {
  padding-top: 4px;
  padding-bottom: 4px;
}
.extraStyle {
}
.anticon-down {
  vertical-align: -0.24rem;
}
</style>

<style lang="css">
.transaction-gray-text {
  font-size: 0.9rem;
  color: #aaa;
  font-weight: normal;
}
h4.transaction {
  font-size: 1.3rem;
  margin-bottom: 0 !important;
  color: #74708d;
}
.demo-loading-container {
  position: absolute;
  bottom: 50%;
  width: 100%;
  text-align: center;
}
.transactions .ant-list-item-action {
  margin-top: 0;
  margin-bottom: 0;
}
.transactions .ant-list-item-action li {
  cursor: default;
}
.transactions .ant-dropdown-link {
  text-transform: none;
  font-weight: normal;
}
.ant-card-head {
}
.ant-card-extra,
.ant-card-head-title {
}
.ant-card-extra {
  padding: 14px 0 11px 0;
}
.transactions .transaction-list-head-title {
  padding-top: -3px;
}
.transaction .ant-list-item-meta {
  cursor: default;
}
strong {
  color: black;
  font-weight: bold;
}
.search-wrapper {
  margin-right: 1rem;
}
.refundIcon :hover,
.refundIconBlack {
  color: rgb(1, 144, 254);
}
.xsStatus {
  display: none;
}
/* .excel-button svg {
  margin-bottom: -1px;
} */
/*ipad*/
@media (max-width: 767px) {
  h4.transaction {
    font-size: 1.1rem;
  }
  .order-by-label,
  .status-label {
    /*display: none;*/
  }
  .transactions .search-wrapper {
    margin-right: 0;
  }
  .transactions .ant-card-head-wrapper {
    display: flex;
    align-items: flex-start;
    flex-flow: column;
  }
  .transactions .ant-card-extra {
    margin-left: 3px;
    padding-top: 0;
  }
  .transactions .ant-card-head-title {
    width: 100%;
  }
}
/*mobile*/
@media (max-width: 576px) {
  .transactions .ant-list-item-meta-avatar {
    margin-right: 6px;
  }
  .transactions .ant-list-item-action {
    margin-left: 5px;
  }
  .transactions .ant-card-body {
    padding-left: 12px;
    padding-right: 12px;
  }
  .xsStatus {
    display: inline;
  }
  .xlStatus {
    display: none;
  }
}
@media only screen and (min-width: 600px) {
  .br-sm {
    display: none;
  }
}
</style>
